import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import quotationImg from "../../assets/images/home/double-quote-review-img.webp";
import "./index.css";

const reviews = [
  {
    id: 1,
    text: "I finally felt heard and understood. So simple, so safe.",
    author: "Anonymous User",
  },
  {
    id: 2,
    text: "Talking here made me realize I am not alone in this journey.",
    author: "Anonymous User",
  },
  {
    id: 3,
    text: "A safe space to open up without fear of judgment.",
    author: "Anonymous User",
  },
  {
    id: 4,
    text: "Such a wonderful way to feel supported anytime I need it.",
    author: "Anonymous User",
  },
  {
    id: 5,
    text: "The listeners here truly care, it gave me hope.",
    author: "Anonymous User",
  },
  {
    id: 6,
    text: "This platform helped me through difficult times.",
    author: "Anonymous User",
  },
  {
    id: 7,
    text: "An amazing way to connect with empathetic listeners.",
    author: "Anonymous User",
  },
  {
    id: 8,
    text: "Finally found a place where I can be myself.",
    author: "Anonymous User",
  },
];

export const ReviewSection = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1,
    }, 
    tablet: { breakpoint: { max: 1024, min: 768 }, items: 2, slidesToSlide: 1 }, 
    mobile: { breakpoint: { max: 768, min: 0 }, items: 1, slidesToSlide: 1 },
  };

  return (
    <div className="reviewContainer">
      <div className="container">
        <div className="reviewHeading text-center">
          <h2>Real Experiences, Real Change</h2>
          <p>
            Discover how ListenAura has made a difference for support seekers
            and Listeners alike.
          </p>
        </div>

        <Carousel
          responsive={responsive}
          showDots={true}
          arrows={false}
          infinite={false}
          keyBoardControl={true}
          containerClass="reviewCarousel"
          dotListClass="custom-dot-list"
          itemClass="carouselItemPadding"
          renderDotsOutside={false}
        >
          {reviews.map((review) => (
            <div key={review.id} className="carouselCard">
              <img src={quotationImg} alt="quote" className="quoteImg" />
              <div className="reviewText">“{review.text}”</div>
              <div className="reviewAuthor">{review.author}</div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};
